import React, { memo } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { AgGridRowResizeDragger } from '../../../dragger/rowResizeDragger'

const SequenceNoLabel = ({ rowNumber }) => (
  <p className="sevend-ag-cell-sequence-no__label">{rowNumber}</p>
)

export const SequenceNoCellRenderer = memo(
  (props: ICellRendererParams) => {
    return (
      <div className="sevend-ag-cell-sequence-no">
        <SequenceNoLabel rowNumber={props.value} />
        {!props.data?.isTotal && !props.context?.isRowHeightFixed && (
          <AgGridRowResizeDragger node={props.node} api={props.api} />
        )}
      </div>
    )
  },
  // カスタム比較関数
  (prevProps, nextProps) => {
    if (prevProps.value !== nextProps.value) return false
    if (prevProps.data?.isTotal !== nextProps.data?.isTotal) return false
    if (
      prevProps.context?.isRowHeightFixed !==
      nextProps.context?.isRowHeightFixed
    ) {
      return false
    }
    return true
  }
)
